import PropTypes from 'prop-types'

import styles from './OtaBuster.module.scss'
import { OTA_BUSTER_CAMPAIGN_STRATEGY } from './campaignFlowMock'

function EmailBadgeIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
      <path
        d="M1.5 3.25A1.25 1.25 0 012.75 2h6.5a1.25 1.25 0 011.25 1.25v5.5A1.25 1.25 0 019.25 10H2.75A1.25 1.25 0 011.5 8.75v-5.5z"
        stroke="currentColor"
        strokeWidth="1.1"
      />
      <path d="M2 3.75l4 2.75 4-2.75" stroke="currentColor" strokeWidth="1.1" />
    </svg>
  )
}

function CampaignStrategyCard({ onManageStrategy }) {
  return (
    <div className={styles.strategyCard} data-testid="ota-buster-campaign-strategy">
      <div className={styles.strategyCopy}>
        <div className={styles.strategyTitleRow}>
          <span className={styles.strategyTitle}>{OTA_BUSTER_CAMPAIGN_STRATEGY.title}</span>
          <span className={styles.strategyChannelBadge}>
            <EmailBadgeIcon />
            {OTA_BUSTER_CAMPAIGN_STRATEGY.channelLabel}
          </span>
        </div>
        <p className={styles.strategySubtitle}>{OTA_BUSTER_CAMPAIGN_STRATEGY.subtitle}</p>
      </div>
      <button
        type="button"
        className={styles.strategyAction}
        onClick={onManageStrategy}
        data-testid="ota-buster-manage-channel-strategy"
      >
        Manage channel strategy
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path
            d="M6 4l4 4-4 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  )
}

CampaignStrategyCard.propTypes = {
  onManageStrategy: PropTypes.func
}

CampaignStrategyCard.defaultProps = {
  onManageStrategy: undefined
}

export default CampaignStrategyCard
